import { GetIssuedPremiumsParams, reportsService } from '@/services';
import { downloadBlob, filenameFromResponse } from '@/shared/utils/download-blob.util';
import { useMutation } from '@tanstack/react-query';

/**
 * Exporta os prêmios emitidos da busca atual para Excel e dispara o download.
 * Em falha, lança a mensagem para a tela exibir o aviso de erro de exportação.
 */
export function useIssuedPremiumsExport() {
  return useMutation({
    mutationFn: async (params: GetIssuedPremiumsParams) => {
      const response = await reportsService.exportIssuedPremiums(params);
      if (!response.ok) {
        throw new Error(
          'Não foi possível exportar a lista de prêmios emitidos no momento. Tente novamente mais tarde.'
        );
      }
      const blob = await response.blob();
      const filename = filenameFromResponse(response, 'premios-emitidos.xlsx');
      downloadBlob(blob, filename);
      return filename;
    },
  });
}
